module.exports = __webpack_public_path__ + "static/img/ico_paper_plane.1d568e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_paper_plane.png
// module id = i03t
// module chunks = 1